import React from 'react'

function Footer() {
  return (
    <footer className="py-4 bg-success">
      <div className="container px-4">
          <div className="d-flex align-items-center justify-content-center small">
              <div className="text-light">Copyright &copy; 2022 - Powered By Mbike Team All rights reserved.</div>
          </div>
      </div>
    </footer>
  )
}

export default Footer
